export var source = "query UserStatsQuery {\n  user {\n    me {\n      stats {\n        orders\n        queue\n        reviews\n        ratedProducts\n      }\n    }\n  }\n}";
export default source;